import React from "react";
import SliderComp from "./CustomizeComponent/SliderComp";
import InputBox from "./CustomizeComponent/InputBox";
import ColorControlerComp from "./CustomizeComponent/ColorControlerComp";
import {
  getL1SheetProperty,
  getL2SheetProperty,
  setLevel2Properties,
} from "../../WorkbookSlice";
import { useDispatch, useSelector } from "react-redux";
import { ContainerWithToggle } from "./CustomizeComponent/ContainerWithToggle";
import CustomSelectComp from "./CustomizeComponent/CustomSelectComp";
import { ContainerWithOutToggle } from "./CustomizeComponent/ContainerWithOutToggle";
// Aside2ConditionalFormatting
import Aside2ConditionalFormatting from "./DropzoneComponents/Aside2ConditionalFormatting"
import { ToggleWithTitle } from "../../../../components/BasicComponents/ToggleWithTitle";
import SelectIcon from "./CustomizeComponent/SelectIcon";
import UploadImage from "./CustomizeComponent/UploadImage";
import TextAlignment from "./CustomizeComponent/TextAlignment";
import SelectColor from "./CustomizeComponent/SelectColor";
import ExpandableWithToggle from "../../../../components/BasicComponents/ExpandableWithToggle";
import IconControllerComp from "./CustomizeComponent/IconControllerComp";

export default function CustomizeComp({
  ControllerProps,
  currentSheet,
  parentKey,
  VizchartType,
}) {
  const { type, itemInArray, reduxKey, title, isParent, defaultType } =
    ControllerProps;
  console.log(ControllerProps);
  const dispatch = useDispatch();
  const dispatchItemToredux = (value, reduxKey) => {
    dispatch(
      setLevel2Properties({
        reduxKey,
        Sheetid: currentSheet.Sheetid,
        parentKey,
        value,
        itemInArray: itemInArray || false,
      })
    );
  };

  const defaultValue = useSelector((state) => {
    var x = getL2SheetProperty(
      state,
      currentSheet.Sheetid,
      parentKey,
      reduxKey
    );
    return x;
  });
  console.log(defaultValue);

  const customizationObject = useSelector((state) =>
    getL1SheetProperty(state, currentSheet.Sheetid, "customization")
  );


  const renderComponent = (type) => {
    switch (type) {
      case "range":
        return (
          <SliderComp
            {...{
              ControllerProps,
              currentSheet,
              parentKey,
              dispatchItemToredux,
              defaultValue,
            }}
          />
        );
      case "checkbox":
        return (
          <ToggleWithTitle
            {...{
              title,
              ControllerProps,
              currentSheet,
              parentKey,
              dispatchItemToredux,
              defaultValue,
              reduxKey,
              isParent,
            }}
          />
        );
      case "CONTAINER_WITH_TOGGLE":
        return (
          <ContainerWithToggle
            {...{
              ControllerProps,
              currentSheet,
              parentKey,
              dispatchItemToredux,
              defaultValue,
            }}
          />
        );
      case "CONTAINER_WITHOUT_TOGGLE":
        return (
          <ContainerWithOutToggle
            {...{
              ControllerProps,
              currentSheet,
              parentKey,
              dispatchItemToredux,
              defaultValue,
            }}
          />
        );
      case "text":
        return (
          <InputBox
            {...{
              ControllerProps,
              currentSheet,
              parentKey,
              dispatchItemToredux,
              defaultValue,
            }}
          />
        );
      case "fontColor":
        return (
          <SelectColor
            ControllerProps={ControllerProps}
            currentSheet={currentSheet}
            dispatchItemToredux={dispatchItemToredux}
            color={customizationObject[reduxKey]}
            defaultValue={defaultValue}

          />
        );
      // fontColor
      case "SELECT_BOX":
        return (
          <CustomSelectComp
            ControllerProps={ControllerProps}
            currentSheet={currentSheet}
            dispatchItemToredux={dispatchItemToredux}
            defaultValue={defaultValue}
            isParent={isParent}
          />
        );
      case "CONDITIONAL_FORMATTING":
        return (
          <Aside2ConditionalFormatting
            currentSheet={currentSheet}
            ControllerProps={ControllerProps}
            VizchartType={VizchartType}
          />
        );
      case "textAlign":
        return (
          <TextAlignment
            currentSheet={currentSheet}
            ControllerProps={ControllerProps}
            dispatchItemToredux={dispatchItemToredux}
          />
        );
      case "searhingIcons":
        return (
          <SelectIcon
            ControllerProps={ControllerProps}
            dispatchItemToredux={dispatchItemToredux}
          />
        );
      case "imageUpload":
        return (
          <UploadImage
            currentSheet={currentSheet}
            ControllerProps={ControllerProps}
            dispatchItemToredux={dispatchItemToredux}
          />
        );
      case "COLOR":
        return (
          <ColorControlerComp
            {...{
              ControllerProps,
              currentSheet,
              parentKey,
              defaultType,
              dispatchItemToredux,
              VizchartType,
            }}
          />
        );
      case "ICON":
        return (
          <IconControllerComp
            {...{
              ControllerProps,
              currentSheet,
              parentKey,
              defaultType,
              dispatchItemToredux,
              VizchartType,
            }}
          />
        );
      case "ICON":
        return (
          <IconControllerComp
            {...{
              ControllerProps,
              currentSheet,
              parentKey,
              dispatchItemToredux,
              VizchartType,
            }}
          />
        );
      default:
        console.error("type is defined")
    }
  };

  return (
    <>
      <main className="h-auto flex flex-col gap-2 items-start justify-start w-full">
        {renderComponent(type)}
      </main>
    </>
  );
}
